
import {Component, Vue } from 'vue-property-decorator'
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from '@/utils/util'
import setPoint from '@/views/operating/group_welfare/components/set-point.vue'
import {apiActivityList, apiActivityStatus, apiActivityDetail} from '@/api/operating/group_welfare/activity'
import { apiSupplierList } from '@/api/operating/group_welfare/point'
@Component({
  components: {
    lsPagination,
    setPoint
  }
})
export default class Activity extends Vue {
  /** S Data*/
  pager: RequestPaging = new RequestPaging();
  supplierPager: RequestPaging = new RequestPaging();
  active:any = 'all'
  query:any = {}
  supplierList = []
  tabCount:any = {
    all: 0,
    waitput: 0,
    wait: 0,
    ing: 0,
    end: 0,
  }
  statusType:any = {
    all: '',
    wait: 1,
    ing: 2,
    end: 3,
  }
  setPointDialog = false
  form:any = {}
  filter = 0
  /** E Data*/
  
  /** S Methods*/
  // 获取供应商列表
  getSupplierList() {
    apiSupplierList({page_no: 1, page_size: 25000}).then(res => {
      this.supplierList = res.lists
    })
  }
  getList(page?:number) {
    console.log(1111)
    page && (this.pager.page = page)
    this.query.put_status = this.active == 'waitput' ? 0 : ''
    this.query.status = this.active != 'waitput' ? (this.statusType[this.active] || '') : ''
    this.pager.request({
      callback: apiActivityList,
      params: {
        ...this.query
      }
    }).then(res => {
      this.tabCount = res.extend
    })
  }
  resetQuery() {
    this.query = {}
    this.getList(1)
  }
  changeTab(val:any) {
    this.getList(1)
  }
  toData(id:any) {
    this.$router.push({
      path: '/operating/group_welfare/activity/data',
      query: {id: id}
    })
  }
  changeStatus(id:any) {
    this.$confirm(`确认下线活动吗？`,'提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      apiActivityStatus({id, status: 3}).then(res => {
        this.getList(1)
      })
    })
  }
  changePoint(item:any, status:number = 0) {
    apiActivityDetail({id: item.id}).then(res => {
      this.form = {
        id: item.id,
        put_type: item.put_type,
        put_status: item.put_status,
        pointIds: res.point_list.map((item:any) => item.shop_id) || []
      }
      this.filter = status
      this.setPointDialog = true
    })
  }
  /** E Methods*/
  created() {
    this.getSupplierList()
    this.getList(1)
  }
}
